/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";
import { cn } from "../../lib/utils";

const themeOptions = [
  { value: "light" as const, icon: Sun, label: "Light" },
  { value: "dark" as const, icon: Moon, label: "Dark" },
  { value: "auto" as const, icon: Monitor, label: "Auto" },
];

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();

  return (
    <div className={cn("p-1 bg-bg-elevated border border-border rounded-xl grid grid-cols-3 gap-2", className)}>
      {themeOptions.map((option) => {
        const Icon = option.icon;
        const isSelected = theme === option.value;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => setTheme(option.value)}
            className={cn(
              "flex items-center justify-center gap-2 py-2 px-3 rounded-xl cursor-pointer",
              isSelected
                ? "bg-bg-base text-text-primary shadow-sm"
                : "text-text-tertiary/60 hover:text-text-secondary hover:bg-bg-hover"
            )}
            aria-label={`Switch to ${option.label} mode`}
          >
            <Icon size={18} strokeWidth={isSelected ? 2.5 : 2} />
          </button>
        );
      })}
    </div>
  );
}
